import { useHotkeys } from "react-hotkeys-hook";
import { useAtomCommand } from "../jotai/atomCommand";
import { clearCodeCommand } from "../state/codeState";

export const useHotKeys = () => {
  const clearCode = useAtomCommand(clearCodeCommand);
  useHotkeys("ctrl+l", clearCode, { enableOnFormTags: true });
};
